import { createTheme, type MantineThemeOverride } from '@mantine/core';
import {
  PALETTE,
  FONTS,
  FONT_SIZES,
  HEADING_SIZES,
  RADIUS,
  SHADOWS,
} from './tokens';

export const travelBuddyTheme: MantineThemeOverride = createTheme({
  primaryColor: 'horizon',
  primaryShade: 4,
  colors: {
    horizon: PALETTE.horizon,
    sand: PALETTE.sand,
    dark: PALETTE.slate,
  },

  fontFamily: FONTS.sans,
  fontFamilyMonospace: FONTS.mono,
  fontSizes: FONT_SIZES,
  headings: {
    fontFamily: FONTS.serif,
    fontWeight: '600',
    sizes: HEADING_SIZES,
  },

  radius: RADIUS,
  defaultRadius: 'md',
  shadows: SHADOWS,

  components: {
    Card: {
      defaultProps: { radius: 'lg', padding: 'lg', withBorder: true },
    },
    Paper: {
      defaultProps: { radius: 'lg', withBorder: true },
    },
    Modal: {
      defaultProps: { radius: 'lg', centered: true },
    },
    Button: {
      defaultProps: { size: 'md', radius: 'md' },
    },
    TextInput: {
      defaultProps: { size: 'md' },
    },
    PasswordInput: {
      defaultProps: { size: 'md' },
    },
    Badge: {
      defaultProps: { radius: 'xl' },
    },
    Loader: {
      defaultProps: { color: 'horizon' },
    },
    Pagination: {
      defaultProps: { color: 'horizon' },
    },
    Checkbox: {
      defaultProps: { color: 'horizon' },
    },
  },
});
